import { useState } from 'react';

const getQuery = () => {
    if (typeof window !== 'undefined') {
        return new URLSearchParams(window.location.search);
    }
    return new URLSearchParams();
};

const getQueryStringVal = (key: string): string | null => {
    return getQuery().get(key);
};

export const useQueryParam = (key: string, replaceState = false): [string, (val?: string) => void, () => void] => {
    const [value, setValue] = useState(getQueryStringVal(key));

    const setQueryParamValue = (newVal: string = '') => {
        setValue(newVal);

        const query = getQuery();
        query.set(key, newVal);

        setNewUrl(query);
    };

    const removeQueryParamKey = () => {
        setValue(null);

        const query = getQuery();
        query.delete(key);

        setNewUrl(query);
    };

    const setNewUrl = (query?: URLSearchParams) => {
        const queryString = query ? query.toString().replace(/=(?=&|$)/g, '') : '';

        if (typeof window !== 'undefined') {
            const { protocol, pathname, host, hash } = window.location;
            const newUrl = `${protocol}//${host}${pathname}${queryString.length > 0 ? `?${queryString}` : ''}${hash}`;
            if (newUrl !== window.location.href) {
                window.history[replaceState ? 'replaceState' : 'pushState']({}, '', newUrl);
            }
        }
    };

    return [value, setQueryParamValue, removeQueryParamKey];
};

export default useQueryParam;
